module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.df02c78.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-brands-400.woff
// module id = 334
// module chunks = 1